import { render, staticRenderFns } from "./image-url.vue?vue&type=template&id=15850c2a"
import script from "./image-url.vue?vue&type=script&lang=ts"
export * from "./image-url.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports